import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Container } from '../container-view/models/container';
import { ContainerType } from '../container-view/models/container-type-enum';
import { ContainerItem } from '../container-view/models/container-item';
import { ContainerMergeService } from '../container-merge/container-merge.service';
import { SelectableLab } from '../carrier/selectable-lab';
import { saveAs as saveByFileSaver } from "file-saver";
import { MessagesService } from '../messages/messages.service';
import { CarrierUtility } from '../utils/carrier-utility';
import { QuadrantViewService } from './quadrant-view.service';
import { PlateListResponse } from './plate-list.response';
import * as jspdf from 'jspdf';
import { ErrorHandler } from '../utils/error-handler';
import { ProcessStep } from '../masterdata/models/processStep-enum';
import { CarrierStatusService } from '../carrier-status/carrier-status.service';
import { CarrierState } from '../masterdata/models/carrierState';
import { Printer } from '../masterdata/models/printer';
import { EchoFileRequest } from '../container-merge/echo-file-request';
import { ReactionPlateState } from '../container-view/models/reaction-plate-state-enum';
import { QCPositionPlacementRequest } from './qc-position-placement-request';
import 'jspdf-autotable';
@Component({
  selector: 'app-quadrant-view',
  templateUrl: './quadrant-view.component.html',
  styleUrls: ['./quadrant-view.component.css']
})
export class QuadrantViewComponent implements OnInit {


  headerColumns1: number[] = [1, 3, 5, 7, 9, 11, 13, 15, 17, 19, 21, 23];
  headerRows1: string[] = ["A", "C", "E", "G", "I", "K", "M", "O"];
  headerColumns2: number[] = [2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24];
  headerRows2: string[] = ["B", "D", "F", "H", "J", "L", "N", "P"];

  isVerticalA1 = false;
  isVerticalB1 = false;
  isVerticalA2 = false;
  isVerticalB2 = false;

  @Output() isVerticalA1Change = new EventEmitter();
  @Output() isVerticalB1Change = new EventEmitter();
  @Output() isVerticalA2Change = new EventEmitter();
  @Output() isVerticalB2Change = new EventEmitter();

  @Output() tabIndexEmitter = new EventEmitter();
  @Output() reactionSetIdEmitter = new EventEmitter();
  @Output() qcReactionsCountEmitter = new EventEmitter();

  @Input() selectedContainer: Container;
  @Input() responseContainers: Container[] = [];
  @Input() hasToggle: boolean;
  @Input() isCarrier: boolean;
  @Input() displayPrimerAndChemicalFilter: boolean;
  @Input() selectedPlateBarcode: string;
  @Input() pendingPlateId: string;
  @Input() plateState: string;

  plateListResponse = {} as PlateListResponse;

  selectedQuadrant: Container;
  selectedLab: SelectableLab;
  errorHandler: ErrorHandler = new ErrorHandler;
  numberOfQCPostionsA1: number;
  numberOfQCPostionsA2: number;
  numberOfQCPostionsB1: number;
  numberOfQCPostionsB2: number;
  carrierUtil: CarrierUtility = new CarrierUtility();

  state: string = 'REACTIONS_PLACED';

  downloadEchoFileError = {
    severity: 'error',
    summary: 'Failed',
    detail: "Download echo file failed"
  }

  quadrantA1: Container;
  quadrantA2: Container;
  quadrantB1: Container;
  quadrantB2: Container;

  @Output() quadrantIdChange = new EventEmitter();

  @Input() quadrantId: string;
  showChemical: boolean;
  showPrimer: boolean;

  cols: any[];
  reactionsToBeCancelled: string[] = [];
  selectAllReactionsToRemove: false;
  selectAllDisabled = false;

  printersList: Printer[];
  selectedPrinter: Printer;
  processStep: string;
  carrierStateDetails: CarrierState;

  echoFileRequest: EchoFileRequest;

  //plateState: string;
  @Output() plateStateEmitter = new EventEmitter();

  /* properties used in printout for quadrant view */
  headerColumnForPrintout: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  headerRowForPrintout: string[] = ["A", "B", "C", "D", "E", "F", "G", "H"];
  onlyQCExists: boolean = false;

  constructor(private _messagesService: MessagesService, private containerMergeService: ContainerMergeService,
    private quadrantViewService: QuadrantViewService, private carrierStatusService: CarrierStatusService,
    private messagesService: MessagesService) {

    this.selectedLab = JSON.parse(localStorage.getItem('lab'));

    this.quadrantA1 = new Container();
    this.quadrantA2 = new Container();
    this.quadrantB1 = new Container();
    this.quadrantB2 = new Container();
  }

  ngOnInit() {
    //get Reactions step MDM configuration
    this.quadrantId = 'A1';
    this.processStep = ProcessStep.REACTIONS_PLACEMENT;
    this.getProcessStepDetail(this.processStep);
  }

  ngOnChanges() {
    if (this.isCarrier) {
      this.selectedQuadrant = this.selectedContainer;
    }
    else {
      this.selectAllDisabled = false;
      this.showChemical = false;
      this.showPrimer = false;
      this.updateQuadrants();
      this.quadrantSelectionChanged(this.quadrantId);
      this.getStorageAndPrimerBarcodeForReactionPlate(this.selectedPlateBarcode);
    }
  }

  /**
  * @function
  * @description: Quadrant change handler
  */
  quadrantSelectionChanged(quadrantId: string) {
    this.quadrantId = quadrantId;
    this.reactionsToBeCancelled = [];
    this.selectAllReactionsToRemove = false;
    if (this.quadrantId == 'A1') {
      this.selectedQuadrant = this.quadrantA1;
      this.onlyQCExists = this.checkContainerItemsInQuadrant(this.responseContainers[0]);
    }
    else if (this.quadrantId == 'A2') {
      this.selectedQuadrant = this.quadrantA2;
      this.onlyQCExists = this.checkContainerItemsInQuadrant(this.responseContainers[1]);
    }
    else if (this.quadrantId == 'B1') {
      this.selectedQuadrant = this.quadrantB1;
      this.onlyQCExists = this.checkContainerItemsInQuadrant(this.responseContainers[2]);
    }
    else {
      this.selectedQuadrant = this.quadrantB2;
      this.onlyQCExists = this.checkContainerItemsInQuadrant(this.responseContainers[3]);
    }
    this.selectedQuadrant.containerType = ContainerType.REACTIONPLATE;
    this.quadrantIdChange.emit(this.quadrantId);
  }
  checkContainerItemsInQuadrant(selectedQuadrant: Container): any {
    let count = 0;
    if (selectedQuadrant != undefined && selectedQuadrant != null && selectedQuadrant.containerItems != null && selectedQuadrant.containerItems != undefined) {
      selectedQuadrant.containerItems.forEach(containerItem => {
        if (containerItem.qcPos)
          count++;

      })
      return selectedQuadrant.containerItems.length === count;
    }
    return false;
  }

  /**
  * @function
  * @description: Axis change handler for A1
  */
  handleAxisChangeA1(e) {
    this.isVerticalA1 = e.checked;
    this.isVerticalA1Change.emit(this.isVerticalA1);
  }

  /**
  * @function
  * @description: Axis change handler for B1
  */
  handleAxisChangeB1(e) {
    this.isVerticalB1 = e.checked;
    this.isVerticalB1Change.emit(this.isVerticalB1);
  }

  /**
  * @function
  * @description: Axis change handler for A2
  */
  handleAxisChangeA2(e) {
    this.isVerticalA2 = e.checked;
    this.isVerticalA2Change.emit(this.isVerticalA2);
  }

  /**
  * @function
  * @description: Axis change handler for B2
  */
  handleAxisChangeB2(e) {
    this.isVerticalB2 = e.checked;
    this.isVerticalB2Change.emit(this.isVerticalB2);
  }

  /**
   * @function
   * @description: Update quadrants
   */
  updateQuadrants() {
    this.updateQuadrant('A1');
    this.updateQuadrant('A2');
    this.updateQuadrant('B1');
    this.updateQuadrant('B2');
  }

  /**
   * @function
   * @description: Updates quadrant
   */
  updateQuadrant(quadrantId: string) {
    let colOffset;
    let rowOffset

    if (quadrantId == 'A1') {
      colOffset = 0;
      rowOffset = 0;
      this.fillQuadrant(this.quadrantA1, colOffset, rowOffset);
    }
    else if (quadrantId == 'A2') {
      colOffset = 12;
      rowOffset = 0;
      this.fillQuadrant(this.quadrantA2, colOffset, rowOffset);
    }
    else if (quadrantId == 'B1') {
      colOffset = 0;
      rowOffset = 8;
      this.fillQuadrant(this.quadrantB1, colOffset, rowOffset);
    }
    else {
      colOffset = 12;
      rowOffset = 8;
      this.fillQuadrant(this.quadrantB2, colOffset, rowOffset);
    }
  }

  /**
   * @function
   * @description: Function to fill the quadrant
   */
  fillQuadrant(quadrantToBeUpdated: Container, colOffset: number, rowOffset: number) {
    quadrantToBeUpdated.containerItems = new Array<ContainerItem>()
    if (this.selectedContainer !== undefined && this.selectedContainer !== null && this.selectedContainer.containerItems !== undefined && this.selectedContainer.containerItems !== null && this.selectedContainer.containerItems.length) {
      quadrantToBeUpdated.barcode = this.selectedContainer.barcode;
      quadrantToBeUpdated.containerState = this.selectedContainer.containerState;
      this.selectedContainer.containerItems.forEach(containerItem => {
        if (containerItem.positionCol > colOffset && containerItem.positionCol <= colOffset + 12 && containerItem.positionRow > rowOffset && containerItem.positionRow <= rowOffset + 8) {
          let newContainerItem: ContainerItem = new ContainerItem();
          newContainerItem.containerItemAware = containerItem.containerItemAware;
          newContainerItem.positionCol = containerItem.positionCol - colOffset;
          newContainerItem.positionRow = containerItem.positionRow - rowOffset;
          quadrantToBeUpdated.containerItems.push(newContainerItem);
        }
      })
    }
  }

  /**
   * @function
   * @description: Retrives carrier items from conatiner
   */
  private fetchCarrierItemBarcode(i: number, j: number, containers: Container[], index: number): string {
    if (this.responseContainers.length > 0 && this.responseContainers[index] !== null) {
      return this.getCarrierItemDispalyBarcode(i, j, containers[index]);
    } else {
      return "";
    }
  }

  /**
   * @function
   * @description: Function dowloads echo file for merged plates
   */
  downloadEchoFile() {
    console.log("REACTION -> DOWNLOAD ECHO FILE");
    this.selectAllDisabled = true;
    this.reactionsToBeCancelled = [];
    //If printer not selected
    if (!this.selectedPrinter) {
      this._messagesService.addErrorMessage({ severity: 'error', summary: "Printer not selected", detail: "Please select the Printer" });
      return;
    }
    if (this.selectedPlateBarcode != null) {
      this.echoFileRequest = new EchoFileRequest();
      this.echoFileRequest.containerBarcode = this.selectedPlateBarcode;
      this.echoFileRequest.labId = this.selectedLab.lab._id;
      this.echoFileRequest.state = this.state;
      this.echoFileRequest.printer = this.selectedPrinter;
      this.containerMergeService.generateEchoFile(this.echoFileRequest).subscribe(
        result => {
          if (!result) {
            return;
          }
          let controllerFileContent = result.echoControllerFileContent;
          this.plateState = result.data.state;
          this.plateStateEmitter.emit(result.data.state);
          let blob: Blob = new Blob([controllerFileContent], { type: 'text/plain' });
          let fileName: string = result.data.barcode + '.csv';
          saveByFileSaver(blob, fileName);
          this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Downloaded successful', detail: 'Downloaded Echo Control file' });
        },
        error => {
          this._messagesService.addErrorMessage(this.downloadEchoFileError);
        }
      );
    }
  }

  /**
 * @function
 * @description: Get CarrierItem Dispaly barcode
 */
  getCarrierItemDispalyBarcode(i: number, j: number, container: Container): string {
    let selectedContainer: Container = container;
    if (selectedContainer === null) {
      return "";
    }

    let currentItem: ContainerItem = this.getContainerItemForIndex(selectedContainer, i, j);

    if (currentItem !== null) {
      return currentItem.displayBarcode;
    }
    return "";
  }

  /**
   * @function
   * @description: Get carrierItem index
   */
  getContainerItemForIndex(selectedCarrier: Container, i: number, j: number): ContainerItem {
    if (selectedCarrier != null && selectedCarrier.containerItems != null)
      for (var y = 0; y < selectedCarrier.containerItems.length; y++) {
        let currentItem: ContainerItem = selectedCarrier.containerItems[y];
        if (currentItem.positionCol == j + 1 && currentItem.positionRow == i + 1) {
          return currentItem;
        }
      }
    return null;
  }

  deleteCurrentPlate() {
    console.log("Delete selected plate")
    this.quadrantViewService.deleteCurrentPlate(this.selectedPlateBarcode)
      .subscribe(results => {
        console.log("succesfully deleted")
        this._messagesService.addSuccessMessage({ severity: 'success', detail: 'Reaction Plate ' + this.selectedPlateBarcode + ' deleted successfully ' });
        this.tabIndexEmitter.emit(0);
      },
        error => {
          console.log("Received error while deleting the plate ")
          console.log(error.error.bbApiError.message)
          this._messagesService.addWarningMessage({ severity: 'warn', detail: error.error.bbApiError.message })
        });
  }

  getStorageAndPrimerBarcodeForReactionPlate(selectedPlateBarcode: string) {
    this.quadrantViewService.getStorageAndPrimerBarcodeForReactionPlate(selectedPlateBarcode).subscribe(
      result => {

        if (!result) { return; }
        this.plateListResponse = result.data;
      }
      ,
      error => {
        console.log(error);
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }
  generatePDF() {

    var doc = new jspdf();
    doc.setFontSize(20);
    doc.text(55, 10, 'Reaction Plate ' + this.selectedPlateBarcode)
    doc.setFontSize(8);
    doc.text(5, 25, 'DNA Plate Barcodes')
    doc.setFontSize(8);
    doc.text(5, 32, this.plateListResponse.dnaPlateBarcodes);
    doc.setFontSize(8);
    doc.text(40, 25, 'DNA Plate Locations')
    doc.setFontSize(7);
    if (this.plateListResponse.dnaPlateLocations != null && this.plateListResponse.dnaPlateLocations != undefined &&
      this.plateListResponse.dnaPlateLocations.length > 0) {
      doc.text(40, 32, this.plateListResponse.dnaPlateLocations);
    }
    doc.text(110, 25, 'Primer Plate Barcodes')
    doc.setFontSize(8);
    doc.text(110, 32, this.plateListResponse.primerPlateBarcodes);
    doc.setFontSize(8);
    doc.text(150, 25, 'Primer Plate Locations')
    doc.setFontSize(7);
    if (this.plateListResponse.primerPlateLocations != null && this.plateListResponse.primerPlateLocations != undefined &&
      this.plateListResponse.primerPlateLocations.length > 0) {
      doc.text(150, 32, this.plateListResponse.primerPlateLocations);
    }

    // Save the PDF
    doc.save(this.selectedPlateBarcode + '.pdf');
  }

  fetchCarrierItemId(i: number, j: number, containers: Container[], index: number): string {

    if (this.responseContainers[index]) {
      let container = this.responseContainers[index];
      if (container != null && container.containerItems != null) {
        for (var y = 0; y < container.containerItems.length; y++) {
          let currentItem: ContainerItem = container.containerItems[y];
          if (currentItem.positionCol == j + 1 && currentItem.positionRow == i + 1) {
            if (currentItem.containerItemAware) {
              return currentItem.containerItemAware._id;
            }
          }
        }
      }
    }
  }

  // disable selection for empty reaction on the reaction plate
  selectBoxDisabledIf(i: number, j: number, containers: Container[], index: number): boolean {
    let flag = false;
    // let reactionPlate: ReactionPlate = <ReactionPlate>containers[index];
    if (this.plateState != null && this.plateState != undefined && ReactionPlateState.REACTIONS_PLACED.toString() === this.plateState) {
      flag = true;
    } else {
      let id = this.fetchCarrierItemId(i, j, containers, index);
      if (id === '' || id === undefined || id === null) {
        flag = true;
      }
    }
    return flag;
  }

  // Emites reaction ids to be removed to the parent
  removeReactions() {
    this.selectAllReactionsToRemove = false;
    this.reactionSetIdEmitter.emit(this.reactionsToBeCancelled);
  }

  // Adds the reaction set selected to an array of all the reaction sets to be removed.
  // or removed the existing reaction sets from the array when unselected.
  selectReactionSet(i: number, j: number, containers: Container[], index: number) {
    const id = this.fetchCarrierItemId(i, j, containers, index);
    if (this.reactionsToBeCancelled && this.reactionsToBeCancelled.length !== 0) {
      this.reactionsToBeCancelled.forEach(reactionSetId => {
        if (reactionSetId === id) {
          this.reactionsToBeCancelled.splice(this.reactionsToBeCancelled.indexOf(id), 1);
        } else if (this.reactionsToBeCancelled.includes(id) === false) {
          this.reactionsToBeCancelled.push(id);
        }
      });
    } else {
      this.reactionsToBeCancelled.push(id);
    }
  }

  // Selects all the reaction sets in current Quadrant of the reaction plate
  selectAllReactions(container: Container, event: any) {
    if (event) {
      this.reactionsToBeCancelled = [];
      const containerItems: any = container.containerItems;
      if (containerItems.lenght !== 0) {
        containerItems.forEach(containerItem => {
          if (containerItem && containerItem.containerItemAware && containerItem.containerItemAware._id && containerItem.qcPos != 1) {
            this.reactionsToBeCancelled.push(containerItem.containerItemAware._id);
          }
        });
      }
    } else {
      this.reactionsToBeCancelled = [];
    }
  }

  // checks if the current element is in the arrau of reaction sets to be removed
  isSelectedToRemove(i: number, j: number, containers: Container[], index: number) {
    const id = this.fetchCarrierItemId(i, j, containers, index);
    let flag = false;
    if (id && this.reactionsToBeCancelled.includes(id) === true) {
      flag = true;
    }
    return flag;
  }

  //get printer details for given mdm step
  getProcessStepDetail(step: string) {
    this.getListOfPrinters();
    this.carrierStateDetails = new CarrierState();

    this.carrierStatusService.getProcessStepDetails(step, this.selectedLab.lab).subscribe(
      results => {
        if (!results) {
          return;
        }
        this.carrierStateDetails = results.data;
        if (!this.carrierStateDetails) {
          this._messagesService.addErrorMessage({ severity: 'error', summary: results.bbApiError.title, detail: results.bbApiError.message });
        } else {
          if (this.carrierStateDetails.printer.active)
            //set default printer for selected mdm step
            this.selectedPrinter = this.carrierStateDetails.printer;
        }
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    )
  }

  //Get list of active printers for selected lab
  getListOfPrinters() {
    this.carrierStatusService.getPrintersList(this.selectedLab.lab, true).subscribe(
      results => {
        if (!results) {
          return;
        }
        this.printersList = results.data;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    )
  }

  getCarrierItemQCPosition(i: number, j: number, container: Container) {
    let selectedContainer: Container = container;
    if (selectedContainer === null) {
      return false
    }

    let currentItem: ContainerItem = this.getContainerItemForIndex(selectedContainer, i, j);

    if (currentItem !== null) {
      return currentItem.qcPos;
    }
    return false;
  }

  isQCReactionSet(i: number, j: number, containers: Container[], index: number) {
    if (this.responseContainers.length > 0 && this.responseContainers[index] !== null) {
      return this.getCarrierItemQCPosition(i, j, containers[index]);
    } else {
      return false;
    }
  }

  hasFreeSpace(containers: Container[], index: number) {
    if (ReactionPlateState.REACTIONS_PLACED.toString() === this.plateState) {
      return true;
    }
    if (containers[index] == null || containers[index] == undefined || containers[index].containerItems == null || containers[index].containerItems == undefined) {
      return false;
    }
    let filledPlaces = containers[index].containerItems.length;
    let availablePlaces = 96 - filledPlaces;
    let qcReactions = containers[index].containerItems.filter(reactionSet => { return reactionSet.qcPos == 1 })
    let numberOfQCPositons = this.getTheNoOfQCReactions(index);
    if (numberOfQCPositons != null && numberOfQCPositons > qcReactions.length) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Warning!', detail: numberOfQCPositons - qcReactions.length + " QC reactions got overwritten" })
    }
    this.storeTheQCCountForQuadrant(index, qcReactions.length)
    return qcReactions.length >= 2 || (qcReactions.length < 2 && availablePlaces == 0 || ReactionPlateState.REACTIONS_PLACED.toString() === this.plateState)
  }

  getTheNoOfQCReactions(index: number) {
    let noOfQc;
    if (index == 0 && this.numberOfQCPostionsA1 != null && this.numberOfQCPostionsA1 != undefined)
      noOfQc = this.numberOfQCPostionsA1;
    else if (index == 1 && this.numberOfQCPostionsA2 != null && this.numberOfQCPostionsA2 != undefined)
      noOfQc = this.numberOfQCPostionsA2;
    else if (index == 2 && this.numberOfQCPostionsB1 != null && this.numberOfQCPostionsB1 != undefined)
      noOfQc = this.numberOfQCPostionsB1
    else if (index == 3 && this.numberOfQCPostionsB2 != null && this.numberOfQCPostionsB2 != undefined)
      noOfQc = this.numberOfQCPostionsB2
    else
      noOfQc = null

    return noOfQc;
  }

  storeTheQCCountForQuadrant(index: number, qcCount: number) {
    if (index == 0)
      this.numberOfQCPostionsA1 = qcCount
    else if (index == 1)
      this.numberOfQCPostionsA2 = qcCount
    else if (index == 2)
      this.numberOfQCPostionsB1 = qcCount
    else if (index == 3)
      this.numberOfQCPostionsB2 = qcCount
  }

  getCSSForQCReaction(i: number, j: number, containers: Container[], index: number) {
    if (this.isQCReactionSet(i, j, containers, index))
      return { 'background-color': 'orange' }
    else
      return {};
  }

  placeQCPositions() {
    let qcRequest = new QCPositionPlacementRequest();
    qcRequest.reactionPlateId = this.pendingPlateId;
    qcRequest.selectedQuadrant = this.quadrantId;

    this.quadrantViewService.placeQcReactionPositions(qcRequest).subscribe(
      result => {
        if (!result || !result.data || result.data.length == 0) {
          this.messagesService.addErrorMessage({ severity: 'error', summary: 'NO PLATE DATA RECEIVED', detail: 'No plate data has been returned by backend' });
          return;
        }
        this.responseContainers = this.createEmptyContainers(result.data);
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this.messagesService.addErrorMessage(message);
      }
    );
  }

  /**
* @function
* @description: Creates empty conatiner if it does not have filled quadrant. This is used for bining purpose
*/
  createEmptyContainers(responseContainers: Container[]) {
    let conatiners: Array<Container> = []
    conatiners.push(new Container());
    conatiners.push(new Container());
    conatiners.push(new Container());
    conatiners.push(new Container());
    responseContainers.forEach(element => {
      if (element.barcode.endsWith("B2")) {
        conatiners.splice(3, 1, element)
      }
      if (element.barcode.endsWith("A2")) {
        conatiners.splice(1, 1, element)
      }
      if (element.barcode.endsWith("B1")) {
        conatiners.splice(2, 1, element)
      }
      if (element.barcode.endsWith("A1")) {
        conatiners.splice(0, 1, element)
      }
    })
    return conatiners;
  }

  ifReactionPlateIsReaction_Placed() {
    return this.plateState != null && this.plateState != undefined && ReactionPlateState.REACTIONS_PLACED.toString() === this.plateState;
  }

  /* Create PDF for reaction plate quadrant view */
  createPDF() {
    const doc = new jspdf('l', 'mm', 'a4');
    let firstQCRow;
    let secondQCRow;
    let firstQCColumn;
    let secondQCColumn;
    let count = 0;
    var container = this.responseContainers[this.getQuadrantPosition(this.quadrantId)];
    for (let i = 0; i < 8; i++) {
      for (let j = 0; j < 12; j++) {
        if (this.getCarrierItemQCPosition(i, j, container)) {

          if (count == 0) {
            firstQCRow = i;
            firstQCColumn = j + 1;
          }
          else {
            secondQCRow = i;
            secondQCColumn = j + 1;
          }

          count++;
        }
      }

    }
    let headerString = this.selectedPlateBarcode.concat('_').concat(this.quadrantId);
    var header = function () {
      doc.setFontSize(18);
      doc.setTextColor(40);
      doc.setFontStyle('normal');
      doc.text(headerString, 10, 15);
    };

    doc.autoTable({
      html: '#tableForPrintView',
      margin: {
        top: 20,
        left: 7,
        useFor: 'page'
      },
      beforePageContent: header,
      columnStyles: {
        0: { cellWidth: 8 },
        1: { cellWidth: 23, fontSize: 7.5 },
        2: { cellWidth: 23, fontSize: 7.5 },
        3: { cellWidth: 23, fontSize: 7.5 },
        4: { cellWidth: 23, fontSize: 7.5 },
        5: { cellWidth: 23, fontSize: 7.5 },
        6: { cellWidth: 23, fontSize: 7.5 },
        7: { cellWidth: 23, fontSize: 7.5 },
        8: { cellWidth: 23, fontSize: 7.5 },
        9: { cellWidth: 23, fontSize: 7.5 },
        10: { cellWidth: 23, fontSize: 7.5 },
        11: { cellWidth: 23, fontSize: 7.5 },
        12: { cellWidth: 23, fontSize: 7.5 },
        13: { cellWidth: 23, fontSize: 7.5 },
      },
      didParseCell: function (data) {
        if ((data.column.index === secondQCColumn && data.row.index === secondQCRow) || (data.column.index === firstQCColumn && data.row.index === firstQCRow)) {
          data.cell.styles.fillColor = [245, 215, 105];
        }
        if (data.cell.raw.classList.contains('hcolumn')) { data.cell.styles.fillColor = [0, 107, 150]; }
        if (data.cell.raw.classList.contains('row')) {
          data.cell.styles.textColor = [0, 107, 150];
          data.cell.styles.fontStyle = 'bold'
        }
      }
    })


    // Save the PDF
    doc.save(this.selectedPlateBarcode.concat('_').concat(this.quadrantId).concat('.pdf'));
  }

  getDisplayPrintBarcode(i: number, j: number, containers: Container[], index: number) {
    if (containers.length > 0 && containers[index] !== null) {
      let selectedContainer: Container = containers[index];
      let currentItem: ContainerItem = this.getContainerItemForIndex(selectedContainer, i, j);
      if (currentItem !== null && currentItem.displayPrintBarcode != null) {
        let str = currentItem.displayPrintBarcode.split("\n").join("\r\n");
        return str;

      }
    } else {
      return "";
    }
  }
  getQuadrantPosition(quadrantId: string) {
    let position;
    if ("A2" === quadrantId)
      position = 1;
    else if ("B1" === quadrantId)
      position = 2;
    else if ("B2" === quadrantId)
      position = 3;
    else
      position = 0
    return position

  }
}
